<template>
  <div>
    <!-- Story Section -->
    <section class="py-20">
      <div class="container mx-auto px-6">
        <div class="gap-12 items-center">
          <div>
            <h2 class="text-4xl font-display font-bold text-gold-400 mb-6">
              Our Story
            </h2>
            <p class="text-gray-300 mb-6 text-justify">
              Canada Smile is a full digital dental laboratory providing high-quality restorations and dependable support to clinics across Canada.
              Using advanced systems such as iTero, 3Shape, and Sirona,…
           </p>
            <p class="text-gray-300 mb-8 text-justify">
              we deliver accurate model printing, fast turnaround times, and consistent digital results.
              Our team combines technology, precision, and clear communication to help clinics achieve predictable and aesthetic outcomes for their patients.
            </p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

export default {
  name: 'About',
  data() {
    return {
    }
  },
}
</script>